<template>
    <div class="af-search-results-sidebar">
        <SalaryFilter
            v-if="showSalaryFilter"
            @go="search"
        />
        <template v-if="$_filterAttributes">
            <LocationFilter v-if="showLocationFilter" />
            <AttributeFilter
                class="afu-hidden"
                v-for="(attribute, attributeKey) in getFilterAttributes"
                :key="attributeKey"
                :attribute-key="attributeKey"
            />
        </template>
        <CustomAttributeFilter
            :selected-filters="$_searchPayload"
        />
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    import SalaryFilter from './SalaryFilter';
    import AttributeFilter from './AttributeFilter';
    import LocationFilter from './LocationFilter';
    import CustomAttributeFilter from './CustomAttributeFilter';

    export default {
        name: 'SearchResultSidebar',

        components: {
            LocationFilter,
            SalaryFilter,
            AttributeFilter,
            CustomAttributeFilter,
        },

        computed: {
            ...mapState({
                $_filterAttributes: state => state.search.searchPayload?.search_results?.aggregation || '',
                $_searchPayload: state => state.search.searchPayload?.search_filters || [],
            }),

            getFilterAttributes() {
                const attributes = JSON.parse(JSON.stringify(this.$_filterAttributes));
                delete attributes.skills;
                delete attributes.job_type;
                delete attributes.contract_type;
                delete attributes.categories;
                delete attributes.occupations;
                delete attributes.location;
                delete attributes.applyflow_custom_1;
                delete attributes.applyflow_custom_2;
                delete attributes.applyflow_custom_3;
                delete attributes.applyflow_custom_4;

                if (window.afConfig?.show_company_filter !== 'Yes') {
                    delete attributes.brands;
                }
                return attributes;
            },

            showSalaryFilter() {
                return (window.afConfig?.hide_salary_filter === 'Yes') ? false : true;
            },

            showLocationFilter() {
                return (window.afConfig?.hide_location_filter === 'Yes') ? false : true;
            },
        },

        methods: {
            search() {
                this.$emit('search');
            },
        },
    };
</script>
